define('pwa/controller/ContactsController',['require','lib/controller/BaseController','pwa/view/controller/contacts/ContactsView','model/CompanyModel'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var ContactsView = require('pwa/view/controller/contacts/ContactsView');
    var CompanyModel = require('model/CompanyModel');

    /**
     * Contacts Controller
     *
     * @class ContactsController
     */
    return BaseController.extend({

        _model: null,
        _view: null,

        contacts: function () {
            this._view = new ContactsView({
                model: this._getModel(),
            });

            this.getMainLayout().getContentRegion().show(this._view);
        },

        /**
         * instantiates and returns CompanyModel instance
         *
         * @reurn CompanyModel
         */
        _getModel: function () {
            if (!this._model) {
                this._model = new CompanyModel();
                this._model.fetch();
            }
            return this._model;
        }

    });

});
